import {createStructuredSelector} from 'reselect';
import {bindActionCreators as bind} from 'redux';
import {isBlank as isCanvasBlank} from '~/selectors/CanvasSelectors';
import {isMultiItemEligible} from '~/selectors/ConfigSelectors';
import {isDirty as isDesignDirty} from '~/selectors/DesignSelectors';
import {selectCartItemsCount, selectCartSubTotal} from '~/api/designs/cartApi';
// slices
import {updateCartItemsCategoryPaths} from '~/slices/cartSlice';

export function select(state, props) {
  return createStructuredSelector({
    cartItemCount: selectCartItemsCount,
    isDesignBlank: isCanvasBlank,
    isDesignDirty,
    isMultiItemEligible,
    subTotal: selectCartSubTotal
  })(state, props);
}

export const actions = dispatch => {
  return {
    ...bind(
      {
        updateCartItemsCategoryPaths
      },
      dispatch
    )
  };
};
